import { makeAutoObservable, runInAction } from "mobx"

import { ActionError, ActionResultStatus, ActionSuccess } from "types/Global"

import { AppUser } from "types/BusinessObjects"

export default class UserStore {
  user: AppUser

  // init function
  constructor() {
    makeAutoObservable(this)
  }

  // actions
  async getOwnUser() {
    const [result, error] = [
      { firstName: "Anonymous", lastName: "User", email: "anonymous@osapiens.com" },
      null,
    ]

    if (!!error) {
      return {
        status: ActionResultStatus.ERROR,
        error,
      } as ActionError
    }
    if (result) {
      const user = result

      runInAction(() => {
        this.user = user
      })

      return {
        status: ActionResultStatus.SUCCESS,
        result: user,
      } as ActionSuccess<AppUser>
    }
    // todo: use this handling as standard
    return {
      status: ActionResultStatus.ERROR,
      error: "Something went wrong.",
    } as ActionError
  }
}
